import React, { useEffect, useState } from 'react';

function HeroSlideshow({ images, interval = 5000, children }) {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (images.length <= 1) return;
    const timer = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % images.length);
    }, interval);
    return () => clearInterval(timer);
  }, [images, interval]);

  return (
    <div className="hero-slideshow">
      {images.map((image, index) => (
        <img
          key={image.src}
          src={image.src}
          alt={image.alt}
          loading={index === 0 ? 'eager' : 'lazy'}
          decoding="async"
          className={`hero-slideshow-image${index === activeIndex ? ' is-active' : ''}`}
        />
      ))}

      {children && <div className="hero-overlay">{children}</div>}

      {images.length > 1 && (
        <div className="hero-dots" role="tablist" aria-label="בחירת תמונה">
          {images.map((image, index) => (
            <button
              key={image.src}
              type="button"
              className={`hero-dot${index === activeIndex ? ' is-active' : ''}`}
              aria-label={`תמונה ${index + 1}`}
              onClick={() => setActiveIndex(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default HeroSlideshow;
